import React from 'react';
import styled from 'styled-components';
import { ButtonGroup, Button } from 'shards-react';

export default function Paginate({
  onPageChange,
  disabled = false,
  disablePrev = disabled,
  disableNext = disabled
}) {
  return (
    <Container>
      <ButtonGroup className="ml-2 mr-2">
        <Button disabled={disablePrev} onClick={() => onPageChange(-1)} outline pill>
          Anterior
        </Button>
        <Button disabled={disableNext} onClick={() => onPageChange(1)} outline pill>
          Siguiente
        </Button>
      </ButtonGroup>
    </Container>
  );
}

const Container = styled.div`
  margin-bottom: 20px;
  text-align: center;
`;
